/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { apiEndpoints } from 'app/core/config/api-endpoints';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { RequestOptions } from 'app/types/network';
import { Transaction } from 'app/types/transaction';

/**
 * Get bulk reposition candidates.
 */

function getBulkRepositionCandidates(
  client: AxiosInstance,
  sourceId: number | string,
  options?: RequestOptions
): Promise<Transaction[]> {
  return client
    .get(
      resolveAppUrl(apiEndpoints.transactionsBulkRepositionCandidates, {
        interpolations: { id: sourceId },
        params: options
      })
    )
    .then(({ data }) => data?.data);
}

/**
 * Export `useGetBulkRepositionCandidates`.
 */

export function useGetBulkRepositionCandidates(sourceId: number | string, options?: RequestOptions) {
  const client = useRequestProvider();

  return useQuery(['bulkRepositionCandidates', sourceId], {
    queryFn: async () => {
      if (!sourceId) {
        return [];
      }

      return await getBulkRepositionCandidates(client, sourceId, options);
    }
  });
}
